<template>
	<el-row class="container">

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editForm" width="30%" :close-on-click-modal="false" :visible.sync="editFormVisible">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="用户名" prop="userName">
					<el-input v-model="editForm.userName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="手机号码" prop="phoneNum">
					<el-input type="number" v-model="editForm.phoneNum" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="角色">
					<el-checkbox-group v-model="checkedRole" class="checkGroup">
						<el-checkbox v-for="(role,index) in roles" :key="role.code" :label="role.code">{{role.name}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="姓名" prop="fullName">
					<el-input v-model="editForm.fullName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="省市区">
					<el-cascader class="w100"
								 expand-trigger="hover"
								 :options="options"
								 v-model="selectedOptions"
					>
					</el-cascader>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--修改密码界面-->
		<el-dialog title="修改密码" v-model="pwdForm" width="50%" :close-on-click-modal="false" :visible.sync="pwdFormVisible">
			<el-form :model="pwdForm" label-width="150px" :rules="pwdFormRules" ref="pwdForm">
				<el-form-item label="原密码" prop="oldPwd">
					<el-input type="password" v-model="pwdForm.oldPwd" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input type="password" v-model="pwdForm.newPwd" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" prop="newPwd2">
					<el-input type="password" v-model="pwdForm.newPwd2" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="pwdFormVisible=false">取消</el-button>
				<el-button type="primary" @click.native="pwdSubmit" :loading="pwdLoading">确认修改</el-button>
			</div>
		</el-dialog>

		<el-col :span="24" class="main" style="z-index:99;	top: 0px;">
			<div><div class="row flex-center pt15 pb30"><img src="../../static/img/logo_hq.png" :class="isCollapse?'Square50':'Square72'"  /></div>
			<el-menu :default-active="$route.path" class="el-menu-vertical-demo" router  :collapse="isCollapse">

				<el-menu-item index="/mainIndex" :class="isCollapse?'ml10':''"><div class="row flex-start h100"><img v-if="$route.path == '/mainIndex'" src="../../static/img/home02_hq.svg" class="black_bg br10 p5"  style="width:20px;height:20px;"/><img v-else src="../../static/img/home01_hq.svg" class="  p5"  style="width:20px;height:20px;"/><span slot="title" class="ml15">主页</span></div>
				</el-menu-item>
				<el-menu-item index="/main" :class="isCollapse?'ml10':''">
<!--					<i class="el-icon-document"></i>-->
					<div class="row flex-start h100"><img v-if="$route.path == '/main'" src="../../static/img/tiancheng02_hq.png" class="black_bg br10 p5" style="width:20px;height:20px;"/><img v-else src="../../static/img/tiancheng01_hq.png" class="  p5" style="width:20px;height:20px;"/><span slot="title"  class="ml15">过磅记录</span></div>
				</el-menu-item>
				<el-menu-item index="/main2" :class="isCollapse?'ml10':''" >
<!--						<i class="el-icon-setting"></i>-->
					<div class="row flex-start h100"><img v-if="$route.path == '/main2'" src="../../static/img/rili02_hq.svg" class="black_bg br10 p5" style="width:20px;height:20px;"/><img v-else src="../../static/img/rili01_hq.svg" class="p5 " style="width:20px;height:20px;"/><span slot="title"  class="ml15">预约称重</span></div>
				</el-menu-item>
				<el-menu-item index="/Customer" :class="isCollapse?'ml10':''" >
					<!--						<i class="el-icon-setting"></i>-->
					<div class="row flex-start h100"><img v-if="$route.path == '/Customer'" src="../../static/img/user02_hq.svg" class="black_bg br10 p5" style="width:20px;height:20px;"/><img v-else src="../../static/img/user01_hq.svg" class="p5 " style="width:20px;height:20px;"/><span slot="title"  class="ml15">客户列表</span></div>
				</el-menu-item>

				<el-menu-item index="/Material" :class="isCollapse?'ml10':''" >
					<div class="row flex-start h100"><img v-if="$route.path == '/Material'" src="../../static/img/wuzi02_hq.svg" class="black_bg br10 p5" style="width:20px;height:20px;"/><img v-else src="../../static/img/wuzi01_hq.svg" class="p5 " style="width:20px;height:20px;"/><span slot="title"  class="ml15">物资管理</span></div>
				</el-menu-item>
				<el-menu-item index="/Car" :class="isCollapse?'ml10':''" >
					<div class="row flex-start h100"><img v-if="$route.path == '/Car'" src="../../static/img/car02_hq.svg" class="black_bg br10 p5" style="width:20px;height:20px;"/><img v-else src="../../static/img/car01_hq.svg" class="p5 " style="width:20px;height:20px;"/><span slot="title"  class="ml15">车辆管理</span></div>
				</el-menu-item>
			</el-menu>
				<div class="position_f" style="bottom:0;">
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" router  :collapse="isCollapse" style="min-height: 40px;">

				<el-menu-item index="/fuwu" :class="isCollapse?'ml10':''" style="display:block;width:100%" >
					<!--						<i class="el-icon-setting"></i>-->
					<div class="row flex-start h100"><img v-if="$route.path == '/fuwu'" src="../../static/img/gongju02_hq.png" class="black_bg br10 p5" style="width:20px;height:20px;"/><img v-else src="../../static/img/gongju01_hq.png" class="p5 " style="width:20px;height:20px;"/><span slot="title"  class="ml15">服务</span></div>
				</el-menu-item>
				<el-menu-item index="/fankui" :class="isCollapse?'ml10':''" >
					<!--						<i class="el-icon-setting"></i>-->
					<div class="row flex-start h100"><img v-if="$route.path == '/fankui'" src="../../static/img/fankui02_hq.png" class="black_bg br10 p5" style="width:20px;height:20px;"/><img v-else src="../../static/img/fankui01_hq.png" class="p5 " style="width:20px;height:20px;"/><span slot="title"  class="ml15">意见反馈</span></div>
				</el-menu-item>

				</el-menu></div>
			</div>
				<!--导航菜单-->
<!--				<el-menu :default-active="$route.path" class="el-menu-vertical-demo"   :collapse="isCollapse"-->
<!--					 unique-opened router   background-color="#fff"   text-color="#000"   active-text-color="#409eff" style="overflow-x:hidden;" >-->
<!--		&lt;!&ndash;			<template v-for="(item,index) in routes" v-if="!item.hidden">-->
<!--						<el-submenu :index="index+''" v-if="!item.leaf">-->
<!--							<template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>-->
<!--							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>-->
<!--						</el-submenu>-->
<!--						<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>-->
<!--					</template>&ndash;&gt;-->
<!--					<template v-for="(item,index) in routes" v-if="!item.hidden">-->
<!--						&lt;!&ndash;有多个节点,第一层&ndash;&gt;-->
<!--						<el-submenu :index="index+''" v-if="!item.leaf" >-->
<!--							<template slot="title"><i :class="item.iconCls"></i>{{isCollapse?'':item.name}}</template>-->
<!--							&lt;!&ndash;第二层&ndash;&gt;-->
<!--							<template v-for="(child,childIndex) in item.children">-->
<!--								<template  v-if="!child.hidden && !item.leaf && item.children.length>0">-->
<!--                                    &lt;!&ndash;有多个节点&ndash;&gt;-->
<!--									<template v-if="child.leaf && !child.hidden">-->
<!--                                        <el-menu-item  :index="child.path" :key="child.path" ><i :class="child.iconCls"></i>{{child.name}}</el-menu-item>-->
<!--									</template>-->
<!--                                    &lt;!&ndash;有多个节点&ndash;&gt;-->
<!--									<template  v-if="!child.leaf && !child.hidden">-->
<!--										<el-submenu :index="child.path"   v-if="!child.hidden && !item.leaf && item.children.length>0">-->
<!--											<template slot="title"><i :class="child.iconCls"></i>{{child.name}}</template>-->
<!--												&lt;!&ndash;第三层&ndash;&gt;-->
<!--                                            <template  v-for="(childSun,childSunIndex) in child.children">-->
<!--                                                <el-menu-item :index="childSun.path"  :key="childSun.path">{{childSun.name}}</el-menu-item>-->
<!--                                            </template>-->
<!--										</el-submenu>-->
<!--									</template>-->
<!--								</template>-->
<!--								<el-menu-item  v-else-if="!child.hidden " :index="child.path" :key="child.path" >{{child.name}}</el-menu-item>-->
<!--							</template>-->
<!--						</el-submenu>-->
<!--						&lt;!&ndash;只有一个节点，第一层&ndash;&gt;-->
<!--						<el-menu-item  v-else  :index="item.path"><i :class="item.iconCls"></i>{{isCollapse?'':item.name}}</el-menu-item>-->
<!--					</template>-->
<!--				</el-menu>-->
			<section class="content-container"  style="height:100%;">
<!--				<el-col :span="24" class="breadcrumb-container p20">-->
<!--						<strong class="title">{{$route.name}}</strong>-->
<!--						<el-breadcrumb separator="/" class="breadcrumb-inner">-->
<!--							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">-->
<!--								{{ item.name }}-->
<!--							</el-breadcrumb-item>-->
<!--						</el-breadcrumb>-->
<!--					</el-col>-->

				<el-col :span="24" class="header font16 position_f " style="top:0;right:0;z-index:9;transition: all 0.5s;" :style="{left:isCollapse?'100px':'200px'}" >
<!--					<el-col :span="10" class="logo row flex-center" :class="isCollapse?'logo-collapse-width pl30 white_bg':'logo-width '">-->
<!--						<img src="../../static/img/logo_hq.png" style="width:33px;height:33px;" />{{isCollapse?'':sysName}}-->
<!--					</el-col>-->
					<el-col :span="4" class="row flex-start">
<!--						<div class="tools" @click="isCollapse = !isCollapse" v-model="isCollapse" >-->
<!--							<i class="fa fa-dedent grey9_text"></i>-->
<!--						</div>-->
<!--						<div :class="isCollapse?'logo-collapse-width pl30 white_bg':'logo-width '"></div>-->
						<div class="font12 black_text tl ml20 fontwb font15">{{$route.name}}</div>
					</el-col>
					<!--			<el-col :span="4">-->
					<!--			<div class="font16">温馨提示：审核内容过期后将会自动删除</div>-->
					<!--			</el-col>-->
					<el-col :span="16" class="userinfo row flex-end w100" :style="{marginRight:isCollapse?'100px':'200px'}" >
						<div class="font12">{{companyName}}已为您服务{{days}}天。</div>
						<div class="position_r pl20 pr20" @click="isCollapse = !isCollapse"><i class="fa fa-dedent"></i></div>
						<div class="position_r pl20 pr20"><div class="position_ac ml10 Square5 red_bg br50" style="margin-top:-5px;"></div><i class="fa fa-volume-up" aria-hidden="true"></i></div>
						<div class=" pl20 pr20"><i class="fa fa-commenting" aria-hidden="true"></i></div>
						<div class="black_bg br5 ml20 mr40" style="width:2px;height:16px;"></div>
						<el-dropdown trigger="hover">
							<span class="el-dropdown-link userinfo-inner" style="color:#000;font-weight:bold;"><img :src="sysUserAvatar" :onerror="errorImg"/> Hello！{{sysUserName}}</span>
							<el-dropdown-menu slot="dropdown">
<!--								<el-dropdown-item>我的消息</el-dropdown-item>-->
<!--									<el-dropdown-item @click.native="handleEdit">基本资料</el-dropdown-item>-->
														<el-dropdown-item @click.native="handleResetPwd">修改密码</el-dropdown-item>
								<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-col>
				</el-col>

				<div class="grid-content bg-purple-light " style="height:90%; margin-top:60px;">
					<el-col :span="24" class="content-wrapper" >
						<transition name="fade" mode="out-in" style="height:100%;">
							<router-view>
                            </router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>
</template>

<script>
	import md5 from 'js-md5';
    import axios from "axios";
    import  {regionData}  from '../assets/data/regioe.js';
    import  {get_now_date,getYearMonth}  from '../utils/date.js';

	export default {
		data() {
			return {
				companyName:'',
				days:'',
				defaultHead: require('../../static/img/default_head.jpg'),
                errorImg:"this.src='../../static/img/default_head.jpg'",
				sysName:'衡七管家智慧称重预约后台管理系统',
				collapsed:false,
				sysUserName: '',
				sysUserAvatar: '',
                isCollapse: true,
                editFormVisible: false,//编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    userName: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ]
                },
                editForm: {
                    id: 0,
                    userName: '',
                    pwd: '',
                    roles: 0,
                    fullName: '',
                    status: 1
                },
				routes:[],
                //联动选择地区
                options: regionData,
                selectedOptions: [],
				checkedRole: [],
				roles: [],
				pwdForm:{
					oldPwd: '',
					newPwd: '',
					newPwd2: ''
				},
				pwdFormVisible: false,
				pwdLoading: false,
				pwdFormRules: {
					oldPwd: [
						{required: true, message: '请输入原始密码.', trigger: 'blur'}
					],
					newPwd: [
						{required: true, message: '请输入新密码.', trigger: 'blur'},
						{min: 6, max: 16, message: '密码长度必须为6至16位.', trigger: 'blur'}
					],
					newPwd2: [
						{required: true, message: '请再次输入新密码.', trigger: 'blur'},
						{min: 6, max: 16, message: '密码长度必须为6至16位.', trigger: 'blur'}
					]
				}
			}
		},
		methods: {
  getDaysBetween(date1){

  let self=this
        self.$axios.get(self.baseApiUrl+'user/getUpUser_4').then(function (res) {
         if(res.data.code==1){
         self.companyName=res.data.data.company_name

            window.localStorage.setItem("company_name", res.data.data.company_name);
         console.log("company_name224")
         console.log(res.data)
         }
        })

  let ab=get_now_date(new Date())
    var  startDate = Date.parse(date1);
    var  endDate = Date.parse(ab);
    console.log(startDate)
    console.log("endDate"+endDate)
    if (startDate>endDate){
        this.days= 0;
        return
    }
    if (startDate==endDate){
        this.days= 1;
        return
    }
    var adays=(endDate - startDate)/(1*24*60*60*1000);
        this.days= adays;
},

			// 显示修改密码
			handleResetPwd:function () {
				this.pwdFormVisible=true;
			},
			// 修改密码
			pwdSubmit: function () {
				this.pwdLoading=true;
                let that = this;
				this.$refs.pwdForm.validate((valid) => {
					if (valid) {
						let user=JSON.parse(window.localStorage.getItem('user'));
                        let params={
                            "new_password_confirm": that.pwdForm.newPwd2,
                            "new_password":that.pwdForm.newPwd,
                            "old_password":that.pwdForm.oldPwd
                        }
						that.$axios.post(that.baseApiUrl + 'user/changePassword', params).then(function (res) {
						console.log("res aa")
						console.log(res)
							that.pwdLoading = false;
  if(res){if(res.data.code==1){
								that.pwdFormVisible = false;
								that.$message({
									type: 'success',
									message: "修改成功."
								});

								that.$refs['pwdForm'].resetFields();
							that.pwdLoading = false;
							}
							}
						}).catch(function (error) {
							that.pwdLoading = false;
								that.$message({
									message: error.message,
									type: 'error'
								});


						});
					} else {
						this.pwdLoading=false;
					}
				});
			},
            //显示编辑界面
            handleEdit:function () {
                this.editFormVisible=true;

                let user=JSON.parse(window.localStorage.getItem('user'));
				this.editForm.id = user.id;

				let params={
					userId: user.id
				};
				let that=this;
				axios.get(this.baseApiUrl+this.AGXPARTNER+'/v1'+'/sysUser/findSysUserById', {params: params}).then(function (res) {
					let userInfo=res.data;
					that.editForm.userName=userInfo.userName;
					that.editForm.phoneNum=userInfo.phoneNum;
					that.checkedRole=userInfo.roles.split(",");
					that.editForm.fullName=userInfo.fullName;
					that.selectedOptions=[];
					that.selectedOptions[0]=userInfo.proCode;
					that.selectedOptions[1]=userInfo.cityCode;
					that.selectedOptions[2]=userInfo.areaCode;

				}).catch(function (error) {
					if (error.response) {
						that.$message({
							type: 'error',
							message: error.message
						});
					}
				});
            },
            //编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;

							let para = Object.assign({}, this.editForm);
							let params={
								id: para.id,
								userName: para.userName,
								fullName: para.fullName,
								phoneNum: para.phoneNum,
								roles: this.checkedRole.toString(),
								proCode: this.selectedOptions[0],
								cityCode: this.selectedOptions[1],
								areaCode: this.selectedOptions[2]
							};
							let that = this;
							console.log(JSON.stringify(params));
							axios.post(this.baseApiUrl+this.AGXPARTNER+'/v1' + '/sysUser/modifySysUser', params).then(function (res) {
								if (res.data == 'SUCCESS') {
									that.$message({
										type: 'success',
										message: "修改成功."
									});

									that.$refs['editForm'].resetFields();
									that.editFormVisible = false;
								}
								that.editLoading = false;
							}).catch(function (error) {
								that.editLoading = false;
								if (error.response) {
									that.$message({
										message: error.message,
										type: 'warning'
									});
								}

							});
						});
					}
				});
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {

                   // this.$axios.post(this.baseApiUrl+this.AGXPARTNER+'/v1'+'/sso/sys/logout',).then(res=>{
                        window.localStorage.removeItem('user');
                        _this.$router.push('/login');

                    //})
				}).catch(() => {

				});
			},
			getRoles: function () {
				/*let that = this;
				axios.get(this.baseApiUrl+this.AGXPARTNER+'/v1' + "/sysUser/getRoles")
						.then((res) => {
							this.roles = Object.assign({}, res.data);
						}).catch(function (error) {
					if (error.response) {
						that.$message({
							message: error.message,
							type: 'warning'
						});
					}
				});*/
                let user = this.baseFun.getLoginUser();
                this.roles= user.userRole;
			}
		},
		mounted() {
			var user = window.localStorage.getItem('user');
			console.log("user1121aaa")
			console.log(user)
			if (user) {
				user = JSON.parse(user);
				this.sysUserName = user.company_name;
					this.sysUserAvatar=user.avatar;
			}
     this.routes=this.$store.getters.getRoutes;
	console.log("routes==3221",this.routes);
	this.getDaysBetween(getYearMonth(user.create_time_text))
	//this.getRoles();
		}
	}
</script>

<style scoped lang="scss">
	@import '~scss_vars';
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			/*background: $color-primary;*/
			background: #f2f6ff;
			color:#000;
			/*border: 1px solid #eee;*/
			text-align:center;
			font-family: "PingFang SC";
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#888;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				height:60px;
				padding-right:20px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin-right:10px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:200px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			position: absolute;

			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 200px;
				width: 200px;
				.el-menu{
					height: 100%;
					width:100%;
				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}.menu-collapsed ul{
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 200px;
				width: 200px;

			}.menu-expanded ul{
				width: 230px;

			}
			.content-container {
				 background: #f2f6ff;
				flex:1;
				overflow-y: scroll;
				.breadcrumb-container {
					margin-bottom: 15px;
					background:#f2f6ff;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #f2f6ff;
					box-sizing: border-box;
					//box-shadow: 0px 0px 8px #eee;
				}
			}
		}
	}
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
    }
	.el-submenu i.fa,.el-menu-item i.fa{margin-right:19px;}
	.el-menu{border-right:0;}
.el-menu--collapse{width:90px;}
.el-menu-item{border-radius:30px 0 0 30px;}
.el-menu-item.is-active{ background: #f2f6ff; color: #000; font-weight:bold;}
</style>



// WEBPACK FOOTER //
// Home.vue?2e86a610